<template>
  <div id="pers-caltax" name="hres8ax-caltax" class="content-pers clearfix">
    <div class="col-xs-12 col-md-12">  

      <div class="income-summary-box clearfix">

        <div class="col-xs-12 col-md-3 rate-topic">
          <div class="col-sm-7 col-xs-12">
            <div class="label-rate">{{ labels['HRES8AXC4']['20'] }}</div>
            <div class="rate color-skin">{{detailCaltax.ratetax}}% </div>
          </div>
          <div class="col-sm-5 col-xs-12"></div>
        </div>

        <div class="col-xs-12 col-md-6 graph-box">
          <div class="graph-1 bg-color-skin" :class="{ 'bg-color-skin-dark-20': detailCaltax.ratetax < 5 }">0%</div>
          <div class="graph-2 bg-color-skin" :class="{ 'bg-color-skin-dark-20': detailCaltax.ratetax >= 5 && detailCaltax.ratetax < 10 }">5%</div>
          <div class="graph-3 bg-color-skin" :class="{ 'bg-color-skin-dark-20': detailCaltax.ratetax >= 10 && detailCaltax.ratetax < 15 }">10%</div>
          <div class="graph-4 bg-color-skin" :class="{ 'bg-color-skin-dark-20': detailCaltax.ratetax >= 15 && detailCaltax.ratetax < 20 }">15%</div>
          <div class="graph-5 bg-color-skin" :class="{ 'bg-color-skin-dark-20': detailCaltax.ratetax >= 20 && detailCaltax.ratetax < 25 }">20%</div>
          <div class="graph-6 bg-color-skin" :class="{ 'bg-color-skin-dark-20': detailCaltax.ratetax >= 25 && detailCaltax.ratetax < 30 }">25%</div>
          <div class="graph-7 bg-color-skin" :class="{ 'bg-color-skin-dark-20': detailCaltax.ratetax >= 30 && detailCaltax.ratetax < 35 }">30%</div>
          <div class="graph-8 bg-color-skin" :class="{ 'bg-color-skin-dark-20': detailCaltax.ratetax >= 35 }">35%</div>
        </div>

        <div class="col-xs-12 col-md-3 tax-pay">
            <div class="label-pay">{{ labels['HRES8AXC4']['30'] }}</div>
            <div class="pay color-skin">{{detailCaltax.amttax}} {{ labels['HRES8AXC4']['60'] }}</div>
        </div>
        
      </div>

      <div class="cal-input-group clearfix">
        <div class="cal-topic clearfix color-skin">{{ labels['HRES8AXC4']['10'] }}</div>

        <div class="col-xs-12 col-md-4 ">
          <div class="icon-summary"><img src="../../assets/img/cal-tax/icon-4-1.png"></div>
          <div class="label-summary">{{ labels['HRES8AXC4']['40'] }}</div>
          <div class="data-summary">{{detailCaltax.amtsalyr}} {{ labels['HRES8AXC4']['60'] }}</div>
        </div>
        <div class="col-xs-12 col-md-4 ">
          <div class="icon-summary"><img src="../../assets/img/cal-tax/icon-4-2.png"></div>
          <div class="label-summary">{{ labels['HRES8AXC4']['50'] }}</div>
          <div class="data-summary">{{detailCaltax.amtdeduct}} {{ labels['HRES8AXC4']['60'] }}</div>
        </div>
        <div class="col-xs-12 col-md-4 ">
          <div class="icon-summary"><img src="../../assets/img/cal-tax/icon-4-3.png"></div>
          <div class="label-summary">{{ labels['HRES8AXC4']['30'] }}</div>
          <div class="data-summary">{{detailCaltax.amttax}} {{ labels['HRES8AXC4']['60'] }}</div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'hres8ax-caltax',
  props: [ 'labels', 'detailCaltax' ]
}
</script>


// WEBPACK FOOTER //
// caltax.vue?1feeaef6